// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:49:59

export default {
  "id": "puzzle-wood-block",
  "slug": "puzzle-wood-block",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/18eed7237fc541478f0d3e692e910079-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/18eed7237fc541478f0d3e692e910079/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Puzzle Wood Block",
      "description": "Put the given blocks of pattern in 9x9 squares to fill them.\nOnce the 9x9 slots are all Filled up, the blocks in it will be cleared!\nAchieve high score by clearing many combos at once!",
      "instructions": "As you start the game, you will see nine 3x3 slot boards and three different patterned blocks on the bottom.\nIf you fill vertical or horizontal 9 slots with given blocks, or fill 3x3 slots, you gain points.\nWhen there is no more space to fill with given blocks, the game stops and you get final records.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "bricks",
        "classic",
        "highscore",
        "tetris",
        "timekiller"
      ]
    },
    "zh-CN": {
      "title": "拼图木块",
      "description": "将给定的图案块放入9x9方格中填充。\n一旦9x9的插槽全部填满，其中的块就会被清除！\n通过一次性清除多个组合来获得高分！",
      "instructions": "游戏开始时，您将看到九个3x3的插槽板和底部三种不同图案的方块。\n如果您用给定的方块填满垂直或水平方向的9个插槽，或填满3x3的插槽，您将获得分数。\n当没有更多空间可以用给定的方块填充时，游戏结束，您将获得最终记录。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "砖块",
        "经典",
        "高分",
        "俄罗斯方块",
        "时间杀手"
      ]
    },
    "zh-TW": {
      "title": "謎題木塊",
      "description": "將給定的圖樣塊放入9x9方格中填滿它們。\n一旦9x9的格槽全部填滿，其中的塊將會被清除！\n通過一次清除多個組合來達成高分！",
      "instructions": "當您開始遊戲時，您將看到九個3x3的插槽板和底部三種不同的圖案塊。\n如果您用給定的塊填滿垂直或水平九個插槽，或填滿3x3的插槽，您將獲得分數。\n當沒有空間再使用給定的塊填滿時，遊戲結束，您將獲得最終紀錄。",
      "genres": [
        "休闲",
        "拼圖"
      ],
      "tags": [
        "磚塊",
        "經典",
        "最高分",
        "俄羅斯方塊",
        "時間消磨者"
      ]
    },
    "zh-HK": {
      "title": "拼圖木塊",
      "description": "將給定的圖案塊放入9x9方格中，以填滿它們。\n一旦9x9格全部填滿，當中的塊將會被清除！\n透過一次清除多個組合來達成高分！",
      "instructions": "遊戲開始時，您會看到九個3x3的插槽板和底部三種不同圖案的分塊。\n當您用給定的塊填滿垂直或水平方向上的9個插槽，或填滿3x3的插槽，您將獲得分數。\n當無法再使用給定的塊填滿空間時，遊戲結束，您將獲得最終紀錄。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "磚塊",
        "經典",
        "最高分",
        "俄羅斯方塊",
        "消磨時間"
      ]
    },
    "ja": {
      "title": "パズル・ウッドブロック",
      "description": "パターンのブロックを9x9のマスに配置して、フィルルする。\n9x9のスロットがすべてフィルルされると、そのブロックがクリアされる！\n一度に多くのコンボをクリアしてハイスコアを目指せ！",
      "instructions": "ゲームを開始すると、9つの3x3のスロットボードと底に配置されている3種類の異なるパターンのブロックが見えます。\n与えられたブロックで垂直または水平に9つのスロットを埋めたり、3x3のスロットを埋めるとポイントを獲得します。\n与えられたブロックで埋める空間がなくなると、ゲームが終了し、最終記録が表示されます。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "ブロック",
        "クラシック",
        "ハイスコア",
        "テトリス",
        "時間殺し"
      ]
    },
    "ko": {
      "title": "퍼즐 우드 블록",
      "description": "주어진 패턴 블록을 9x9 정사각형에 배치하여 채우세요.\n9x9 슬롯이 모두 채워지면, 그 안의 블록이 지워집니다!\n한 번에 많은 컴보를 지우면서 높은 스코어를 달성하세요!",
      "instructions": "게임을 시작하면 9개의 3x3 슬롯 보드와 아래에 세 가지 다른 패턴 블록을 볼 수 있습니다.\n주어진 블록으로 가로나 세로 9개의 슬롯을 채우거나 3x3 슬롯을 채우면 점수를 얻습니다.\n주어진 블록으로 더 채울 공간이 없으면 게임이 중지되고 최종 기록을 얻습니다.",
      "genres": [
        "캐주얼",
        "패ズル"
      ],
      "tags": [
        "브릭스",
        "클래식",
        "하이스코어",
        "테트리스",
        "시간쟁이"
      ]
    },
    "fr": {
      "title": "Puzzle en blocs de bois",
      "description": "Placer les blocs de motifs fournis dans des carrés de 9x9 pour les remplir.\nUne fois que les cases de 9x9 sont toutes remplies, les blocs à l'intérieur seront effacés !\nObtenez un score élevé en effaçant de nombreux combos en même temps !",
      "instructions": "Au début du jeu, vous verrez neuf grilles de slots 3x3 et trois blocs de motifs différents en bas.\nSi vous remplissez 9 cases verticales ou horizontales avec les blocs donnés, ou si vous remplissez une grille 3x3, vous gagnez des points.\nLorsqu'il n'y a plus de place pour remplir avec les blocs donnés, le jeu s'arrête et vous obtenez les records finals.",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "briques",
        "classique",
        "record haut",
        "tetris",
        "temps mort"
      ]
    }
  }
};
